// src/utils/bibit-extractor.js

/**
 * Helper: Ambil karakter ke-7 dari bibit untuk menentukan Kelas Bibit
 * Format bibit contoh: "NFMD2SB4"
 * @param {string} bibit - Kode bibit
 * @returns {string} Kelas bibit (karakter ke-7) atau '-'
 */
export const getKelasBibit = (bibit) => {
    if (!bibit || bibit === '') {
        return '-';
    }
    
    const bibitString = String(bibit);
    if (bibitString.length >= 7) {
        const seventhChar = bibitString.charAt(6); // Index 6 = karakter ke-7
        return seventhChar;
    }
    return '-';
};

/**
 * Helper: Ambil Jenis Bibit (karakter ke-6)
 * Format bibit contoh: "NFMD2SB4"
 * @param {string} bibit - Kode bibit
 * @returns {string} Jenis bibit (karakter ke-6) atau '-'
 */
export const getJenisBibit = (bibit) => {
    if (!bibit || bibit === '') {
        return '-';
    }
    
    const bibitString = String(bibit);
    if (bibitString.length >= 7) {
        const sixthChar = bibitString.charAt(5); // Index 5 = karakter ke-6
        return sixthChar;
    }
    return '-';
};

export default {
    getKelasBibit,
    getJenisBibit
};